// @flow
import React, { Component } from 'react';
import { Field } from 'redux-form';
import { DefaultIcon } from '../../../../components/Icon';
import {
  WalletWrapperDiv,
  WalletContentDiv,
  CurrencyH4
} from '../CryptoWalletsStyles';
import WalletInput from './WalletInput';
import validateAddress from '../../../../utilities/addressValidator';
import { type Currency } from '../../../../utilities/types';

type Props = {
  currency: Currency
};

export default class Wallet extends Component<Props> {
  validateAddress = (value: string) => {
    if (!value) {
      return undefined;
    }
    if (!validateAddress(value, this.props.currency.iso4217)) {
      return 'Invalid address';
    }
  };

  render() {
    const iso = this.props.currency.iso4217.toLowerCase();
    return (
      <WalletWrapperDiv>
        <WalletContentDiv>
          <DefaultIcon name={iso} color={this.props.currency.color} />
          <CurrencyH4>{this.props.currency.name}</CurrencyH4>
        </WalletContentDiv>
        <Field
          label="wallet addresess"
          name={`${iso}_wallet_address`}
          component={WalletInput}
          focus
          validate={this.validateAddress}
        />
      </WalletWrapperDiv>
    );
  }
}
